import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => {
    // 只忽略重复导航错误，其他错误应该继续传递
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err)
    }
    return err
  })
}
Router.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err)
    }
    return err
  })
}
Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/login",
      name: "Login",
      meta: {requireAuth: false},
      component: resolve => require(['@/pages/login'],resolve),
    },
    {
      // 登录页面使用的协议展示页（新窗口打开，无需登录）
      path: "/login-agreement",
      name: "LoginAgreement",
      meta: {requireAuth: false, title: '用户协议与隐私政策'},
      component: resolve => require(['@/pages/login-agreement/index'],resolve),
    },
    {
      path: "/password",
      name: "Password",
      meta: {requireAuth: false},
      component: resolve => require(['@/pages/password'],resolve),
    },
    {
      path: "/intelligent",
      name: "Intelligent",
      meta: {requireAuth: false},
      component: resolve => require(['@/pages/intelligent'],resolve),
    },
    {
      path: "/loginGuide",
      name: "LoginGuide",
      meta: {requireAuth: false},
      component: resolve => require(['@/pages/loginGuide'],resolve),
    },
    {
      path: "/education-login",
      name: "EducationLogin",
      meta: {requireAuth: false},
      component: resolve => require(['@/pages/education-login'],resolve),
    },
    {
      path: "/education-dashboard",
      name: "EducationDashboard",
      meta: {requireAuth: false},
      component: (resolve) => {
        return require(['@/pages/education-dashboard'], (module) => {
          resolve(module);
        });
      }
    },
    {
      path: "/education-warning-detail",
      name: "EducationWarningDetail",
      meta: {requireAuth: false},
      component: resolve => require(['@/pages/education-warning-detail'], resolve)
    },
    {
      path: "/education-warning-detail-py",
      name: "EducationWarningPyDetail",
      meta: {requireAuth: false},
      component: resolve => require(['@/pages/education-warning-detail-py'], resolve)
    },
    // 管理员端
    {
      path: '/admin',
      component: resolve => require(['@/pages/admin/layout'], resolve),
      meta: { requireAuth: true, role: 'admin' },
      children: [
        {
          path: '/admin_home',
          name: 'AdminHome',
          component: resolve => require(['@/pages/admin/home'], resolve),
          meta: { requireAuth: true, title: '管理员首页', role: 'admin', permission: 'admin' }
        },
        {
          path: '/edu_bureau',
          name: 'EduBureauManage',
          component: resolve => require(['@/pages/admin/edu_bureau'], resolve),
          meta: { requireAuth: true, title: '教育局管理', role: 'admin', permission: 'eduBureau' }
        },
        {
          path: '/school_manage',
          name: 'SchoolManage',
          component: resolve => require(['@/pages/admin/school_manage'], resolve),
          meta: { requireAuth: true, title: '学校管理', role: 'admin', permission: 'schoolManage' }
        },
        // {
        //   path: '/admin_profile',
        //   name: 'AdminProfile',
        //   component: resolve => require(['@/pages/admin/profile'], resolve),
        //   meta: { requireAuth: true, title: '个人设置', role: 'admin' }
        // },
        {
          path: '/system_log',
          name: 'SystemLog',
          component: resolve => require(['@/pages/admin/system_log'], resolve),
          meta: { requireAuth: true, title: '系统日志', role: 'admin', permission: 'systemLog' }
        },
        {
          path: '/system_usage',
          name: 'SystemUsage',
          component: resolve => require(['@/pages/admin/system_usage'], resolve),
          meta: { requireAuth: true, title: '系统使用量', role: 'admin', permission: 'systemUsage' }
        }
      ]
    },
    // 老师端
    {
      path: '/index',
      component: resolve => require(['@/pages/index'],resolve),
      children:[
        {
          path:'/sch_home',
          name:'schHome',
          component: resolve => require(['@/pages/school/home'],resolve),
          meta: {requireAuth: true,title: '首页',visiable: true,role: 'teacher',icon: '1',type: '1'}
        },
        {
          path:'/dialogue_usage_ranking',
          name:'DialogueUsageRanking',
          component: resolve => require(['@/pages/school/dialogue-usage-ranking'],resolve),
          meta: {requireAuth: true,title: '对话灵悦统计',visiable: false,role: 'teacher',auth: '1'}
        },
        // {
        //   path:'/admin_home',
        //   name:'AdminHome',
        //   component: resolve => require(['@/pages/admin/home'],resolve),
        //   meta: {requireAuth: true,title: '管理员首页',visiable: true,role: 'teacher',icon: '1',type: '1'}
        // },
        {
          path: '/class_index',
          component: resolve => require(['@/pages/school/class/index'],resolve),
          meta: {requireAuth: true,title: '教务管理',visiable: true,role: 'teacher',icon: '2',type: '2',show: false},
          children: [
            {
              path:'/teacher',
              name:'Teacher',
              component: resolve => require(['@/pages/school/class/teacher'],resolve),
              meta: {requireAuth: true,title: '教师管理',visiable: true,role: 'teacher',icon: 'sc_2',type: '2'}
            },
            {
              path:'/class',
              name:'Class',
              component: resolve => require(['@/pages/school/class/home'],resolve),
              meta: {requireAuth: true,title: '班级管理',visiable: true,role: 'teacher',icon: 'sc_1',type: '2'}
            },
            {
              path:'/student',
              name:'Student',
              component: resolve => require(['@/pages/school/class/student'],resolve),
              meta: {requireAuth: true,title: '学生管理',visiable: true,role: 'teacher',icon: 'sc_3',type: '2'}
            },
            {
              path:'/profile',
              name:'Profile',
              component: resolve => require(['@/pages/school/class/profile'],resolve),
              meta: {requireAuth: true,title: '个人档案',visiable: false}
            },
          ]
        },
        {
          path: '/assess',
          component: resolve => require(['@/pages/school/assess/index'],resolve),
          meta: {requireAuth: true,title: '团体测评',visiable: true,role: 'teacher',icon: '5',type: '5',show: false},
          children: [
            {
              path:'/workbench',
              name:'AssessWorkbench',
              component: resolve => require(['@/pages/school/assess/workbench'],resolve),
              meta: {requireAuth: true,title: '工作台',visiable: true,role: 'teacher',icon: 'sc_27',type: '5'}
            },
            {
              path:'/scale',
              name:'Scale',
              component: resolve => require(['@/pages/school/assess/scale'],resolve),
              meta: {requireAuth: true,title: 'AI智能测评',visiable: true,role: 'teacher',icon: 'sc_4',type: '5'}
            },
            {
              path:'/basic_team',
              name:'BasicTeam',
              component: resolve => require(['@/pages/school/assess/basic_team'],resolve),
              meta: {requireAuth: true,title: '基础团测',visiable: true,role: 'teacher',icon: 'sc_29',type: '5',permission: '团体测评'}
            },
            {
              path:'/basic_team_create',
              name:'BasicTeamCreate',
              component: resolve => require(['@/pages/school/assess/basic_team_create'],resolve),
              meta: {requireAuth: true,title: '创建基础团测',visiable: false,role: 'teacher',auth: 'sc_29'}
            },
            {
              path:'/create',
              name:'Create',
              component: resolve => require(['@/pages/school/assess/create'],resolve),
              meta: {requireAuth: true,title: '编辑团测',visiable: false,role: 'teacher',auth: 'sc_4'}
            },
            {
              path:'/team_assess_students',
              name:'TeamAssessStudents',
              component: resolve => require(['@/pages/school/assess/team_assess_students'],resolve),
              meta: {requireAuth: true,title: '测评完成情况',visiable: false,role: 'teacher',auth: 'sc_4'}
            },
            {
              path:'/basic_team_students',
              name:'BasicTeamStudents',
              component: resolve => require(['@/pages/school/assess/basic_team_students'],resolve),
              meta: {requireAuth: true,title: '基础团测-完成情况',visiable: false,role: 'teacher',auth: 'sc_29'}
            },
            {
              path:'/team_report',
              name:'teamReport',
              component: resolve => require(['@/pages/school/assess/team_report'],resolve),
              meta: {requireAuth: true,title: '团体统一自测-团体报告',visiable: false,role: 'teacher',auth: 'sc_4'}
            },
            {
              path:'/basic_team_report',
              name:'BasicTeamReport',
              component: resolve => require(['@/pages/school/assess/basic_team_report'],resolve),
              meta: {requireAuth: true,title: '基础团测-团体报告',visiable: false,role: 'teacher',auth: 'sc_29'}
            },
            {
              path:'/individual',
              name:'Individual',
              component: resolve => require(['@/pages/school/assess/individual'],resolve),
              meta: {requireAuth: true,title: '个体报告',visiable: false,role: 'teacher',auth: 'sc_4'}
            },
            {
              path:'/individual_report',
              name:'IndividualReport',
              component: resolve => require(['@/pages/school/assess/individual_report'],resolve),
              meta: {requireAuth: true,title: '团体报告-个体报告',visiable: false,role: 'teacher',auth: 'sc_4'}
            },
            {
              path:'/student_report',
              name:'studentReport',
              component: resolve => require(['@/pages/school/assess/student_report'],resolve),
              meta: {requireAuth: true,title: '团体统一自测-个体报告',visiable: false,role: 'teacher',auth: 'sc_4'}
            },
            {
              path:'/student_report1',
              name:'studentReport1',
              component: resolve => require(['@/pages/school/assess/student_report1'],resolve),
              meta: {requireAuth: true,title: '团体统一自测-个体报告',visiable: false,role: 'teacher',auth: 'sc_4'}
            },
            {
              path:'/self_scale',
              name:'SelfScale',
              component: resolve => require(['@/pages/school/assess/self_scale'],resolve),
              meta: {requireAuth: true,title: '自我测评',visiable: true,role: 'teacher',icon: 'sc_5',type: '5'}
            },
            {
              path:'/analysis',
              name:'Analysis',
              component: resolve => require(['@/pages/school/assess/analysis'],resolve),
              meta: {requireAuth: true,title: '自我测评分析报告',visiable: false,role: 'teacher',auth: 'sc_5'}
            },
            {
              path:'/self_list',
              name:'SelfList',
              component: resolve => require(['@/pages/school/assess/self_list'],resolve),
              meta: {requireAuth: true,title: '自我测评学生',visiable: false,role: 'teacher',auth: 'sc_5'}
            },
            {
              path:'/warning_students',
              name:'WarningStudents',
              component: resolve => require(['@/pages/school/assess/warning-students'],resolve),
              meta: {requireAuth: true,title: '预警学生',visiable: true,role: 'teacher',icon: 'sc_28',type: '5'}
            }
          ]
        },
        // {
        //   path: '/sandbox_system1',
        //   name:'SandboxSystem1',
        //   component: resolve => require(['@/pages/school/sandbox1/index'],resolve),
        //   meta: {requireAuth: true,title: '心理沙盘解析',visiable: true,role: 'teacher',icon: '24',type: '24',show: false},
        //   children: [
        //                  {
        //        path:'sandbox_therapy1',
        //        name:'SandboxTherapy1',
        //        component: resolve => require(['@/pages/school/sandbox1/therapy'],resolve),
        //        meta: {requireAuth: true,title: '新建解析',visiable: true,role: 'teacher',icon: 'sc_25',type: '24'}
        //      },
        //      {
        //        path:'sandbox_history1',
        //        name:'SandboxHistory1',
        //        component: resolve => require(['@/pages/school/sandbox1/history'],resolve),
        //        meta: {requireAuth: true,title: '解析记录',visiable: true,role: 'teacher',icon: 'sc_26',type: '24'}
        //      },
            
        //   ]
        // },
        {
          path: '/counseling',
          component: resolve => require(['@/pages/school/counseling/index'],resolve),
          meta: {requireAuth: true,title: '心理咨询室',visiable: true,role: 'teacher',icon: '18',type: '18',show: false},
          children: [
            {
              path:'/counseling_dashboard',
              name:'CounselingDashboard',
              component: resolve => require(['@/pages/school/counseling/dashboard'],resolve),
              meta: {requireAuth: true,title: '工作台',visiable: true,role: 'teacher',icon: 'sc_13',type: '18'}
            },
            {
              path:'/counseling_rooms',
              name:'CounselingRooms',
              component: resolve => require(['@/pages/school/counseling/rooms'],resolve),
              meta: {requireAuth: true,title: '功能室管理',visiable: true,role: 'teacher',icon: 'sc_14',type: '18'}
            },
            {
              path:'/counselors',
              name:'Counselors',
              component: resolve => require(['@/pages/school/counseling/counselors'],resolve),
              meta: {requireAuth: true,title: '心理老师管理',visiable: true,role: 'teacher',icon: 'sc_15',type: '18'}
            },
            {
              path:'/counseling_statistics',
              name:'CounselingStatistics',
              component: resolve => require(['@/pages/school/counseling/statistics'],resolve),
              meta: {requireAuth: true,title: '统计分析',visiable: true,role: 'teacher',icon: 'sc_16',type: '18'}
            },
            {
              path:'/leave_management',
              name:'LeaveManagement',
              component: resolve => require(['@/pages/school/counseling/leave'],resolve),
              meta: {requireAuth: true,title: '请假管理',visiable: true,role: 'teacher',icon: 'sc_17',type: '18'}
            },
            {
              path:'/counseling_schedule',
              name:'CounselingSchedule',
              component: resolve => require(['@/pages/school/counseling/schedule'],resolve),
              meta: {requireAuth: true,title: '排班管理',visiable: true,role: 'teacher',icon: 'sc_22',type: '18'}
            }
          ]
        },
        {
          path: '/sch_career',
          component: resolve => require(['@/pages/school/career/index'],resolve),
          meta: {requireAuth: true,title: '职业规划',visiable: true,role: 'teacher',icon: '12',type: '12',show: false},
          children: [
            {
              path:'/mbti',
              name:'Mbti',
              component: resolve => require(['@/pages/school/career/mbti'],resolve),
              meta: {requireAuth: true,title: 'MBTI职业倾向测评',visiable: true,role: 'teacher',icon: 'sc_6',type: '12'}
            },
            {
              path:'/hld',
              name:'Hld',
              component: resolve => require(['@/pages/school/career/hld'],resolve),
              meta: {requireAuth: true,title: '霍兰德职业倾向测评',visiable: true,role: 'teacher',icon: 'sc_7',type: '12'}
            },
            {
              path:'/disc',
              name:'Disc',
              component: resolve => require(['@/pages/school/career/disc'],resolve),
              meta: {requireAuth: true,title: 'DISC个性测评',visiable: true,role: 'teacher',icon: 'sc_8',type: '12'}
            },
            {
              path:'/career_report',
              name:'CareerReport',
              component: resolve => require(['@/pages/school/career/career_report'],resolve),
              meta: {requireAuth: true,title: '职业生涯规划测评报告',visiable: false,role: 'teacher',auth: '12'}
            },
          ]
        },
        {
          path: '/sch_intervene',
          name:'SchIntervene',
          component: resolve => require(['@/pages/school/intervene'],resolve),
          meta: {requireAuth: true,title: '干预手段',visiable: true,role: 'teacher',icon: '11',type: '11'}
        },
        {
          path: '/sch_training',
          name:'SchTraining',
          component: resolve => require(['@/pages/school/training'],resolve),
          meta: {requireAuth: true,title: '认知训练',visiable: true,role: 'teacher',icon: '13',type: '13'}
        },
        {
          path:'/training_report',
          name:'TrainingReport',
          component: resolve => require(['@/pages/school/training_report'],resolve),
          meta: {requireAuth: true,title: '认知训练-报告',visiable: false,role: 'teacher',auth: '13'}
        },
        {
          path: '/system',
          component: resolve => require(['@/pages/school/system/index'],resolve),
          meta: {requireAuth: true,title: '系统管理',visiable: true,role: 'teacher',icon: '6',type: '6',show: false},
          children: [
            // {
            //   path:'/role',
            //   name:'Role',
            //   component: resolve => require(['@/pages/school/system/role'],resolve),
            //   meta: {requireAuth: true,title: '角色管理',visiable: true,role: 'teacher',icon: 'sc_10',type: '6'}
            // },
            {
              // 教师端系统日志：使用相对路径避免与管理员端 /system_log 冲突
              path: 'system_log',
              name: 'SchoolSystemLog',
              component: resolve => require(['@/pages/school/system/log'], resolve),
              meta: { requireAuth: true, title: '系统日志', visiable: true, role: 'teacher', icon: 'sc_11', type: '6' }
            },
            {
              path:'/setting',
              name:'Setting',
              component: resolve => require(['@/pages/school/system/setting'],resolve),
              meta: {requireAuth: true,title: '学生账号设置',visiable: true,role: 'teacher',icon: 'sc_12',type: '6'}
            },
            {
              path:'/teacher_profile',
              name:'TeacherProfile',
              component: resolve => require(['@/pages/school/system/profile'],resolve),
              meta: {requireAuth: true,title: '个人中心',visiable: (function(){ try { const u = JSON.parse(localStorage.getItem('mental_user_info')||'{}'); return u && u.type === 'teacher' } catch(e){ return false } })(),role: 'teacher',icon: 'sc_13',type: '6'}
            },
            {
              path:'feedback',
              name:'SchoolFeedback',
              component: resolve => require(['@/pages/common/feedback/index'],resolve),
              meta: {requireAuth: true,title: '意见反馈',visiable: true,role: 'teacher',icon: 'sc_24',type: '6'}
            },

          ]
        },
        {
          path:'/class_report',
          name:'classReport',
          component: resolve => require(['@/pages/school/class_report'],resolve),
          meta: {requireAuth: true,title: '团体统一自测-班级报告',visiable: false,role: 'teacher',type: '2'}
        },
        {
          path:'/no_test',
          name:'noTest',
          component: resolve => require(['@/pages/school/no_test'],resolve),
          meta: {requireAuth: true,title: '未测评学生',visiable: false,role: 'teacher',auth: '1'}
        },
        {
          path:'/warning',
          name:'Warning',
          component: resolve => require(['@/pages/school/warning'],resolve),
          meta: {requireAuth: true,title: '预警学生',visiable: false,role: 'teacher',auth: '1'}
        },
        {
          path: '/sch_tuning',
          component: resolve => require(['@/pages/school/tuning/index'],resolve),
          meta: {requireAuth: true,title: '调优',visiable: false,role: 'teacher',auth: 'sc_4'},
          children: [
            {
              path:'/tuning_home',
              name:'Tuning',
              component: resolve => require(['@/pages/school/tuning/home'],resolve),
              meta: {requireAuth: true,title: '调优模式',visiable: true,role: 'teacher',auth: 'sc_4'}
            },
            {
              path:'/tuning_record',
              name:'TuningRecord',
              component: resolve => require(['@/pages/school/tuning/record'],resolve),
              meta: {requireAuth: true,title: '调优记录',visiable: true,role: 'teacher',auth: 'sc_4'}
            }
          ]
        },
        {
          path: '/message',
          name:'Message',
          component: resolve => require(['@/pages/school/message'],resolve),
          meta: {requireAuth: true,title: '消息列表',visiable: false,role: 'teacher',auth: '1'}
        },
        // 心理老师预约管理  
        {
          path: '/counselor_appointment',
          component: resolve => require(['@/pages/counselor/appointment/index'],resolve),
          meta: {requireAuth: true,title: '心理咨询室',visiable: true,role: 'teacher',icon: '20',type: '20',show: false},
          children: [
            {
              path:'counselor_dashboard',
              name:'CounselorDashboard',
              component: resolve => require(['@/pages/counselor/appointment/dashboard'],resolve),
              meta: {requireAuth: true,title: '工作台',visiable: true,role: 'teacher',icon: 'sc_18',type: '20'}
            },
            {
              path:'counselor_appointments',
              name:'CounselorAppointments',
              component: resolve => require(['@/pages/counselor/appointment/appointments'],resolve),
              meta: {requireAuth: true,title: '预约管理',visiable: true,role: 'teacher',icon: 'sc_19',type: '20'}
            },
            {
              path:'schedule_management',
              name:'ScheduleManagement',
              component: resolve => require(['@/pages/counselor/appointment/schedule'],resolve),
              meta: {requireAuth: true,title: '排班管理',visiable: true,role: 'teacher',icon: 'sc_20',type: '20'}
            },
            {
              path:'leave_management_counselor',
              name:'LeaveManagementCounselor',
              component: resolve => require(['@/pages/counselor/appointment/leave'],resolve),
              meta: {requireAuth: true,title: '请假管理',visiable: true,role: 'teacher',icon: 'sc_21',type: '20'}
            },
            {
              path:'counselor_rating',
              name:'RatingManagement',
              component: resolve => require(['@/pages/counselor/appointment/rating'],resolve),
              meta: {requireAuth: true,title: '评价管理',visiable: true,role: 'teacher',icon: 'sc_23',type: '20'}
            },
            {
              path:'assessment_report',
              name:'AssessmentReport',
              component: resolve => require(['@/pages/counselor/appointment/assessment_report'],resolve),
              meta: {requireAuth: true,title: '测评报告',visiable: false,role: 'teacher',auth: 'sc_23'}
            },
            {
              path:'counseling_report',
              name:'CounselingReport',
              component: resolve => require(['@/pages/counselor/appointment/counseling_report'],resolve),
              meta: {requireAuth: true,title: '咨询报告',visiable: false,role: 'teacher',auth: 'sc_19'}
            },
            {
              path:'appointment_detail/:id',
              name:'AppointmentDetail',
              component: resolve => require(['@/pages/counselor/appointment/appointment_detail'],resolve),
              meta: {requireAuth: true,title: '预约详情',visiable: false,role: 'teacher',auth: 'sc_19'}
            }
          ]
        },
        // 学生端
        {
          path:'/stu_home',
          name:'stuHome',
          component: resolve => require(['@/pages/student/home'],resolve),
          meta: {requireAuth: true,title: '首页',visiable: true,role: 'student',icon: '7'}
        },
        {
          path: '/group',
          component: resolve => require(['@/pages/student/group/index'],resolve),
          meta: {requireAuth: true,title: '团体测评',visiable: true,role: 'student',icon: '9',show: false},
          children: [
            {
              path:'/group_incomplete',
              name:'Incomplete',
              component: resolve => require(['@/pages/student/group/incomplete'],resolve),
              meta: {requireAuth: true,title: '待完成测评',visiable: true,role: 'student',icon: 'st_4'}
            },
            {
              path:'/group_complete',
              name:'Complete',
              component: resolve => require(['@/pages/student/group/complete'],resolve),
              meta: {requireAuth: true,title: '已完成测评',visiable: true,role: 'student',icon: 'st_5'}
            },
            {
              path:'/report',
              name:'Report',
              component: resolve => require(['@/pages/student/group/report'],resolve),
              meta: {requireAuth: true,title: '团体统一自测-个体报告',visiable: false,role: 'student',icon: 'st_6'}
            }
          ]
        },
        {
          path: '/student_counseling',
          component: resolve => require(['@/pages/student/counseling/index'],resolve),
          meta: {requireAuth: true,title: '心理预约',visiable: true,role: 'student',icon: '19',type: '19',show: false},
          children: [
            {
              path:'/counseling_dashboard',
              name:'StudentCounselingDashboard',
              component: resolve => require(['@/pages/student/counseling/dashboard'],resolve),
              meta: {requireAuth: true,title: '工作台',visiable: true,role: 'student',icon: 'st_7',type: '19'}
            },
            {
              path:'/appointment_management',
              name:'StudentAppointmentManagement',
              component: resolve => require(['@/pages/student/counseling/appointment'],resolve),
              meta: {requireAuth: true,title: '预约管理',visiable: true,role: 'student',icon: 'st_8',type: '19'}
            },
            {
              path:'/rating_management',
              name:'StudentRatingManagement',
              component: resolve => require(['@/pages/student/counseling/rating'],resolve),
              meta: {requireAuth: true,title: '评价管理',visiable: true,role: 'student',icon: 'st_9',type: '19'}
            }
          ]
        },
        {
          path: '/self',
          component: resolve => require(['@/pages/student/self/index'],resolve),
          meta: {requireAuth: true,title: '自我测评',visiable: true,role: 'student',icon: '8',show: false},
          children: [
            {
              path:'/self_incomplete',
              name:'SelfIncomplete',
              component: resolve => require(['@/pages/student/self/incomplete'],resolve),
              meta: {requireAuth: true,title: '测评列表',visiable: true,role: 'student',icon: 'st_1'}
            },
            {
              path:'/self_complete',
              name:'SelfComplete',
              component: resolve => require(['@/pages/student/self/complete'],resolve),
              meta: {requireAuth: true,title: '测评记录',visiable: true,role: 'student',icon: 'st_2'}
            },
            {
              path:'/self_report',
              name:'SelfReport',
              component: resolve => require(['@/pages/student/self/self_report'],resolve),
              meta: {requireAuth: true,title: '自我测评报告',visiable: false,role: 'student',icon: 'st_3'}
            }
          ]
        },
        // {
        //   path: '/dialogueLY',
        //   name:'DialogueLY',
        //   component: resolve => require(['@/pages/common/dialogueLY/index'],resolve),
        //   meta: {requireAuth: true,title: 'Future you',visiable: true,role: 'student',icon: '17'},
        // },
        {
          path: '/maindialog',
          name:'MainDialog',
          // eslint-disable-next-line spellcheck/spell-checker
          component: resolve => require(['@/pages/common/dialogueLY/maindialog'],resolve),
          meta: {requireAuth: true,title: '对话界面',visiable: false,role: 'student'},
        },
        {
          path: '/dialogue_detail',
          name:'DialogueDetail',
          // eslint-disable-next-line spellcheck/spell-checker
          component: resolve => require(['@/pages/common/dialogueLY/detail'],resolve),
          meta: {requireAuth: true,title: '对话灵悦详情',visiable: false,role: 'teacher',auth: '1'},
        },
        {
          path: '/stu_career',
          name:'StuCareer',
          component: resolve => require(['@/pages/student/career'],resolve),
          meta: {requireAuth: true,title: '职业规划',visiable: true,role: 'student',icon: '13'}
        },
        {
          path: '/career_result',
          name:'CareerResult',
          component: resolve => require(['@/pages/student/career_result'],resolve),
          meta: {requireAuth: true,title: '职业生涯规划测评报告',visiable: false,role: 'student'}
        },
        {
          path: '/stu_intervene',
          name:'StuIntervene',
          component: resolve => require(['@/pages/student/intervene'],resolve),
          meta: {requireAuth: true,title: '干预手段',visiable: true,role: 'student',icon: '14'}
        },
        {
          path:'/video',
          name:'video',
          component: resolve => require(['@/pages/student/video'],resolve),
          meta: {requireAuth: true,title: '干预手段—视频播放',visiable: false,role: 'student'}
        },
        {
          path: '/training',
          name:'Training',
          component: resolve => require(['@/pages/student/training'],resolve),
          meta: {requireAuth: true,title: '认知训练',visiable: true,role: 'student',icon: '15'}
        },
        {
          path: '/training_detail',
          name:'TrainingDetail',
          component: resolve => require(['@/pages/student/training_detail'],resolve),
          meta: {requireAuth: true,title: '认知训练',visiable: false,role: 'student'}
        },
        {
          path:'/intro',
          name:'Intro',
          component: resolve => require(['@/pages/student/intro'],resolve),
          meta: {requireAuth: true,title: '测评简介',visiable: false,role: 'student'}
        },
        {
          path:'/choice_intro',
          name:'ChoiceIntro',
          component: resolve => require(['@/pages/student/choice_intro'],resolve),
          meta: {requireAuth: true,title: '测评简介',visiable: false,role: 'student'}
        },
        {
          path:'/test',
          name:'Test',
          component: resolve => require(['@/pages/student/test'],resolve),
          meta: {requireAuth: true,title: '测评',visiable: false,role: 'student'}
        },
        {
          path:'/choice_test',
          name:'ChoiceTest',
          component: resolve => require(['@/pages/student/choice_test'],resolve),
          meta: {requireAuth: true,title: '测评',visiable: false,role: 'student'}
        },
        {
          path:'/ai_test',
          name:'AiTest',
          component: resolve => require(['@/pages/student/ai_test'],resolve),
          meta: {requireAuth: true,title: '团体测评',visiable: false,role: 'student'}
        },
        {
          path: '/examine',
          name:'Examine',
          component: resolve => require(['@/pages/student/examine'],resolve),
          meta: {requireAuth: true,title: '个人中心',visiable: true,role: 'student',icon: '16'}
        },
        {
          path: '/student_feedback',
          name:'StudentFeedback',
          component: resolve => require(['@/pages/common/feedback/index'],resolve),
          meta: {requireAuth: true,title: '意见反馈',visiable: true,role: 'student',icon: '17'}
        },
        {
          path: '/privacy-permission',
          name:'PrivacyPermission',
          component: resolve => require(['@/pages/student/privacy-permission'],resolve),
          meta: {requireAuth: false,title: '隐私与权限',visiable: false,role: 'student'}
        },
        {
          path:'/historyRecord',
          name:'HistoryRecord',
          component: resolve => require(['@/pages/common/dialogueLY/historyRecord'],resolve),
          meta: {requireAuth: true,title: '历史记录',visiable: false,role: 'student'}
        },
      ]
    },
    {
      path: "/developer",
      name: "Developer",
      meta: {requireAuth: false},
      component: resolve => require(['@/pages/developer'],resolve),
    }
  ]
})

// 全局守卫：
router.beforeEach((to, from, next) => {

  let userType = ''
  try { const u = JSON.parse(localStorage.getItem('mental_user_info') || '{}'); userType = u && u.type ? u.type : '' } catch (e) {}

  // 动态同步菜单可见性（侧边栏若依据 meta.visiable 渲染会生效）
  try {
    const indexRoute = router.options.routes.find(r => r.path === '/index')
    if (indexRoute && indexRoute.children) {
      const systemRoute = indexRoute.children.find(r => r.path === '/system')
      if (systemRoute && systemRoute.children) {
        const tp = systemRoute.children.find(r => r.path === '/teacher_profile')
        if (tp && tp.meta) { tp.meta.visiable = userType === 'teacher' }
      }
    }
  } catch (e) {}

  // 访问拦截：非教师禁止进入教师个人中心
  if (to.path === '/system/teacher_profile' && userType !== 'teacher') {
    // 根据用户类型跳回各自首页
    return next(userType === 'student' ? '/stu_home' : '/index/sch_home')
  }

  next()
})

// afterEach 钩子用于追踪导航完成
router.afterEach((to, from) => {
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js